const WhyCleartaxNew = ({ Heading, title }) => (
  <section className="lil-container lil-flex lil-flex-wrap lil-pt-10 lil-pb-8 sm:lil-mt-12">
    <div className="lil-w-2/3 sm:lil-w-full sm:lil-pr-8">
      <Heading title={title} />
    </div>
    <div className="lil-w-full lil-flex lil-flex-wrap">
      <div className="lil-w-1/3 lil-py-6 lil-outline-none sm:lil-w-full sm:lil-py-0">
        <div className="lil-promise-horizontal lil-rounded-xl lil-bg-white lil-shadow-xl lil-my-6 lil-mx-4 lil-p-4 lil-py-auto sm:lil-mx-0 card-height sm:lil-py-8 sm:lil-shadow-md">
          <div className="lil-promise-icon-wrapper sm:lil-pb-2">
            <img
              className="lil-h-12"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1609348543_saving.png"
            />
          </div>
          <div className="lil-pt-4 md:lil-pb-2 sm:lil-pt-0">
            <p className="lil-text-s-24 lil-text-font-500 lil-font-bold lil-pb-6 sm:lil-text-s-20 sm:lil-pb-2">
              Choose from best funds
            </p>
            <p className="lil-w-full lil-h-24 xl:lil-h-auto md:lil-w-full sm:lil-w-full sm:lil-h-10 sm:lil-pb-16">
              Invest in hand-picked top performing Mutual funds
            </p>
          </div>
        </div>

        <div className="lil-promise-horizontal lil-rounded-xl lil-bg-white lil-shadow-xl lil-my-6 lil-mx-4 lil-p-4 lil-py-auto sm:lil-mx-0 sm:lil-my-2 card-height sm:lil-shadow-md">
          <div className="lil-promise-icon-wrapper sm:lil-pb-2">
            <img
              className="lil-h-12"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1631016490_group17111.svg"
            />
          </div>
          <div className="lil-pt-4 md:lil-pb-2 sm:lil-pt-0">
            <p className="lil-text-s-24 lil-text-font-500 lil-font-bold lil-pb-6 sm:lil-text-s-20 sm:lil-pb-2">
              Bank graded security
            </p>
            <p className="lil-w-full lil-h-24 xl:lil-h-auto md:lil-w-full sm:lil-w-full sm:lil-h-10 sm:lil-pb-16">
              Data security is our top priority. 128 Bit Bank Grade SSL. ISO
              27001 DC.
            </p>
          </div>
        </div>
      </div>

      <div className="lil-w-1/3 lil-py-6 lil-outline-none sm:lil-w-full sm:lil-py-0">
        <div className="lil-promise-horizontal lil-rounded-xl lil-bg-white lil-shadow-xl lil-my-6 lil-mx-4 lil-p-4 lil-py-auto sm:lil-mx-0 card-height sm:lil-py-8 sm:lil-shadow-md">
          <div className="lil-promise-icon-wrapper sm:lil-pb-2">
            <img
              className="lil-h-12"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1631016057_icon.svg"
            />
          </div>
          <div className="lil-pt-4 md:lil-pb-2 sm:lil-pt-0">
            <p className="lil-text-s-24 lil-text-font-500 lil-font-bold lil-pb-6 sm:lil-text-s-20 sm:lil-pb-2">
              Easy to invest
            </p>
            <p className="lil-w-full lil-h-24 xl:lil-h-auto md:lil-w-full sm:lil-w-full sm:lil-h-10 sm:lil-pb-16">
              Sign up and start investing online within minutes.
            </p>
          </div>
        </div>

        <div className="lil-promise-horizontal lil-rounded-xl lil-bg-white lil-shadow-xl lil-my-6 lil-mx-4 lil-p-4 lil-py-auto sm:lil-mx-0 sm:lil-my-2 card-height sm:lil-py-8 sm:lil-shadow-md">
          <div className="lil-promise-icon-wrapper sm:lil-pb-2">
            <img
              className="lil-h-12"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1631016344_group17103.svg"
            />
          </div>
          <div className="lil-pt-4 md:lil-pb-2 sm:lil-pt-0">
            <p className="lil-text-s-24 lil-text-font-500 lil-font-bold lil-pb-6 sm:lil-text-s-20 sm:lil-pb-2">
              Easy to withdraw
            </p>
            <p className="lil-w-full lil-h-24 xl:lil-h-auto md:lil-w-full sm:lil-w-full sm:lil-h-10 sm:lil-pb-16">
              Withdraw anytime in 1-click with no paperwork needed
            </p>
          </div>
        </div>
      </div>

      <div className="lil-w-1/3 lil-py-6 lil-outline-none sm:lil-w-full sm:lil-py-0">
        <div className="lil-promise-horizontal lil-rounded-xl lil-bg-white lil-shadow-xl lil-my-6 lil-mx-4 lil-p-4 lil-py-auto sm:lil-mx-0 card-height sm:lil-py-8 sm:lil-shadow-md">
          <div className="lil-promise-icon-wrapper sm:lil-pb-2">
            <img
              className="lil-h-12"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1631016202_group17301.svg"
            />
          </div>
          <div className="lil-pt-4 md:lil-pb-2 sm:lil-pt-0">
            <p className="lil-text-s-24 lil-text-font-500 lil-font-bold lil-pb-6 sm:lil-text-s-20 sm:lil-pb-2">
              Easy to track
            </p>
            <p className="lil-w-full lil-h-24 xl:lil-h-auto md:lil-w-full sm:lil-w-full sm:lil-h-10 sm:lil-pb-16">
              Track / monitor your investments 24*7 on your dashboard
            </p>
          </div>
        </div>

        <div className="lil-promise-horizontal lil-rounded-xl lil-bg-white lil-shadow-xl lil-my-6 lil-mx-4 lil-p-4 lil-py-auto sm:lil-mx-0 sm:lil-my-2 card-height sm:lil-py-8 sm:lil-shadow-md">
          <div className="lil-promise-icon-wrapper sm:lil-pb-2">
            <img
              className="lil-h-12"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1631016279_group17104.svg"
            />
          </div>
          <div className="lil-pt-4 md:lil-pb-2 sm:lil-pt-0">
            <p className="lil-text-s-24 lil-text-font-500 lil-font-bold lil-pb-6 sm:lil-text-s-20 sm:lil-pb-2">
              Instant investment proof
            </p>
            <p className="lil-w-full lil-h-24 xl:lil-h-auto md:lil-w-full sm:lil-w-full sm:lil-h-10 sm:lil-pb-16">
              Get your 80C investment proof instantly and submit to HR.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyCleartaxNew;



// WEBPACK FOOTER //
// ./components/plan/whyCleartaxNew.tsx